import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/system/menu/menu';
import waves from '@/directive/waves'; // 水波纹指令

import menuAdd from './add';
import apiPerm from './apiPermission';
export default {
  name: 'ComplexTable',
  components: {
    menuAdd: menuAdd,
    apiPerm: apiPerm
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      menuId: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogApiVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleApi: function handleApi(menuId) {
      this.menuId = menuId;
      this.title = '接口权限';
      this.dialogApiVisible = true;
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
      this.dialogApiVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.menuId = -1;
      this.title = '创建';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(menuId) {
      this.menuId = menuId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(menuIds) {
      var _this2 = this;

      if (menuIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(menuIds).then(function (response) {
            if (response.data.code === 200) {
              _this2.getList();

              _this2.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(menuId) {
      var menuIds = [];
      menuIds.push(menuId);
      this.delete(menuIds);
    },
    handleDeletes: function handleDeletes() {
      var menuIds = [];
      this.multipleSelection.forEach(function (row) {
        menuIds.push(row.menuId);
      });
      this.delete(menuIds);
    }
  }
};